import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface BetaBadgeProps {
  active: boolean;
}

/** "✦ BETA" pill for a sidebar entry that is still in beta. Twinkles on row hover. */
export function BetaBadge({ active }: BetaBadgeProps) {
  const { t } = useTranslation();

  return (
    <Badge
      variant='outline'
      className={cn(
        'ms-auto gap-1 px-1.5 py-0 text-[10px] font-semibold uppercase leading-4 tracking-wide transition-colors',
        active
          ? 'border-white/30 bg-white/20 text-sd-primary-foreground'
          : 'border-sd-primary/50 bg-sd-primary/25 text-sd-foreground group-hover:bg-sd-primary/40',
      )}
    >
      <Sparkles
        aria-hidden
        className='h-3 w-3 transition-transform duration-300 motion-safe:group-hover:rotate-12 motion-safe:group-hover:scale-125'
      />
      {String(t('beta'))}
    </Badge>
  );
}

/** Collapsed sidebar: a dot on the icon stands in for the pill. */
export function BetaDot({ active }: BetaBadgeProps) {
  return (
    <span
      aria-hidden
      className={cn(
        'absolute -end-0.5 -top-0.5 h-1.5 w-1.5 rounded-full',
        active ? 'bg-sd-primary-foreground' : 'bg-sd-primary',
      )}
    />
  );
}
